import axios, { AxiosInstance } from 'axios'
import store from '@/store'
import { getHemisphereToken, refreshHemisphereToken } from '@/composables/auth'

interface SessionConfig {
  headerProvider?: () => object
  deconnectionHandler?: () => void
}

export function getHemisphereSessionToken(): string | null {
  return getHemisphereToken()
}

export function notifyHemisphereSessionExpired() {
  refreshHemisphereToken()
}

export default class ClientService {
  client: AxiosInstance
  constructor(baseURL: string, sessionConfig: SessionConfig) {
    const options = {
      baseURL: baseURL
    }
    this.client = axios.create(options)

    if (sessionConfig.headerProvider) {
      const headerProvider = sessionConfig.headerProvider
      this.client.interceptors.request.use(
        async (config: any) => {
          // merge headers with request headers last to allow override of default headers
          config.headers = { ...headerProvider(), ...config.headers }
          return config
        },
        (error: any) => {
          Promise.reject(error)
        }
      )
    }

    if (sessionConfig.deconnectionHandler) {
      const deconnectionHandler = sessionConfig.deconnectionHandler
      this.client.interceptors.response.use(
        function (response: any) {
          return response
        },
        function (error: any) {
          if (axios.isCancel(error)) {
            throw new axios.Cancel('Operation canceled by the user.')
          }

          if (error.response.status === 401) {
            deconnectionHandler()
          }
          return Promise.reject(error)
        }
      )
    }
  }

  public handleError(error: Error, errorValue: any): Promise<any> {
    console.log(error)
    return Promise.resolve(errorValue)
  }
}
